const stagingConfig = require('./index.staging');

module.exports = {
  ...stagingConfig,
  environment: 'production',
  gaTrackingId: 'UA-142628868-1',
  baseURL: 'https://rupiahtoken.com',
  apiURL: 'https://api.rupiahtoken.com',
  firebase: {
    apiKey: 'AIzaSyBJXgg8O8LkoRPBJKueMqxV3FSnoPJFtJA',
    authDomain: 'rupiahtoken-production.firebaseapp.com',
    databaseURL: 'https://rupiahtoken-production.firebaseio.com',
    projectId: 'rupiahtoken-production',
    storageBucket: 'rupiahtoken-production.appspot.com',
    messagingSenderId: '1012641375616',
    appId: '1:1012641375616:web:a7dc6bec57c00c17'
  }
};
